import { render, staticRenderFns } from "./taskItem.vue?vue&type=template&id=4730ed42&scoped=true&"
import script from "./taskItem.vue?vue&type=script&lang=js&"
export * from "./taskItem.vue?vue&type=script&lang=js&"
import style0 from "../less/commentsHub.less?vue&type=style&index=0&module=true&lang=less&"
import style1 from "./taskItem.vue?vue&type=style&index=1&id=4730ed42&lang=less&scoped=true&"

var cssModules = {}
var disposed = false

function injectStyles (context) {
  if (disposed) return
  
        cssModules["$style"] = (style0.locals || style0)
        Object.defineProperty(this, "$style", {
          configurable: true,
          get: function () {
            return cssModules["$style"]
          }
        })
      
}


  module.hot && module.hot.dispose(function (data) {
    disposed = true
  })



        module.hot && module.hot.accept(["../less/commentsHub.less?vue&type=style&index=0&module=true&lang=less&"], function () {
          var oldLocals = cssModules["$style"]
          if (oldLocals) {
            var newLocals = require("../less/commentsHub.less?vue&type=style&index=0&module=true&lang=less&")
            if (JSON.stringify(newLocals) !== JSON.stringify(oldLocals)) {
              cssModules["$style"] = newLocals
              require("/home/ganttpro/app/node_modules/vue-hot-reload-api/dist/index.js").rerender("4730ed42")
            }
          }
        })

/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  "4730ed42",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/ganttpro/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4730ed42')) {
      api.createRecord('4730ed42', component.options)
    } else {
      api.reload('4730ed42', component.options)
    }
    module.hot.accept("./taskItem.vue?vue&type=template&id=4730ed42&scoped=true&", function () {
      api.rerender('4730ed42', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "public/views/commentHub/include/taskItem.vue"
export default component.exports